<div class="text-info text-lower-initial tw-flex tw-items-center tw-flex-col ">
   <p class="truncate">Elige cuál medición utilizar:</p>
  <nz-select [(ngModel)]="measurementType" (ngModelChange)="onChange()" class="chose-measurement">
    <nz-option *ngIf="this.gebValue > 0" nzValue="geb" [nzLabel]="'Gasto energético basal - ' + gebValue.toFixed(2) + ' kcal'"></nz-option>
    <nz-option *ngIf="this.tmbValue > 0" nzValue="tmb" [nzLabel]="'Tasa metabólica basal - ' + tmbValue.toFixed(2) + ' kcal'"></nz-option>
    <nz-option *ngIf="this.getValue > 0" nzValue="get" [nzLabel]="'Gasto energético total - ' + getValue.toFixed(2) + ' kcal'"></nz-option>
  </nz-select>
</div>

<p class="text-info text-lower-initial tw-mt-5 tw-mb-2">
  Determinar la cantidad de calorías que deseas {{ trackingValue === 'deficit' ? 'disminuir' : 'aumentar'}}
</p>
<div class="tw-flex tw-flex-col md:tw-flex-row tw-items-center">
  <nz-radio-group [(ngModel)]="trackingValue" nzButtonStyle="solid" (ngModelChange)="onChange()" class="tw-w-full md:tw-w-max ">
    <label nz-radio-button nzValue="deficit" class="tw-w-1/2 md:tw-w-max decrease-calories">Disminuir</label>
    <label nz-radio-button nzValue="surplus" class="tw-w-1/2 md:tw-w-max increase-calories">Aumentar</label>
  </nz-radio-group>
  <nz-input-number class="tw-mt-3 tw-w-full tw-max-w-full md:tw-mt-0 md:tw-max-w-[120px] md:tw-w-max md:tw-ml-3 input-calories" [nzFormatter]="formatterKcal"
  [nzParser]="parserKcal" [(ngModel)]="calories" [nzMin]="0" [nzMax]="this.trackingValue === 'deficit' ? this.measurementCalories : this.mathInfinity" [nzStep]="1" (ngModelChange)="onChange()"></nz-input-number>
</div>

<p class="tw-text-gray-400 tw-text-xs text-lower-initial tw-mt-3">
  <i nz-icon nzType="info-circle" nzTheme="outline"></i>
  Se mostrarán alertas mientras va cambiando el plan de alimentación
</p>
